var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainy6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.05
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur)",
    id: "rainy-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.7,35.4c0-4.6-3.7-8.2-8.2-8.2c-1,0-1.9,0.2-2.8,0.5c-0.3-3.4-3.1-6.2-6.6-6.2c-3.7,0-6.7,3-6.7,6.7c0,0.8,0.2,1.6,0.4,2.3    c-0.3-0.1-0.7-0.1-1-0.1c-3.7,0-6.7,3-6.7,6.7c0,3.6,2.9,6.6,6.5,6.7l17.2,0C44.2,43.3,47.7,39.8,47.7,35.4z",
    fill: "#57A0EE",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    transform: "translate(-20,-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31,46), rotate(10)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "am-weather-rain-1",
    fill: "none",
    stroke: "#91C0F8",
    strokeDasharray: "4,4",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(-4,1)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "am-weather-rain-2",
    fill: "none",
    stroke: "#91C0F8",
    strokeDasharray: "4,4",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(0,-1)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "am-weather-rain-1",
    fill: "none",
    stroke: "#91C0F8",
    strokeDasharray: "4,4",
    strokeLinecap: "round",
    strokeWidth: 2,
    transform: "translate(4,0)",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy6);
export default __webpack_public_path__ + "static/media/rainy-6.cd7c6f534c492c7101a55c23911cfa07.svg";
export { ForwardRef as ReactComponent };